module.exports = __webpack_public_path__ + "static/media/Sportive use telemedicine software for digital healthcare.37a62832.webp";